import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid grid-equalize" }
const _hoisted_2 = { class: "col-6" }
const _hoisted_3 = { class: "quiz-personal-stage-lightning-round__selectable-button-emoji" }
const _hoisted_4 = { class: "col-6" }
const _hoisted_5 = { class: "quiz-personal-stage-lightning-round__selectable-button-emoji" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Continue ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuizSelectableButton = _resolveComponent("QuizSelectableButton")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_QuizCard = _resolveComponent("QuizCard")!

  return (_openBlock(), _createBlock(_component_QuizCard, {
    title: _ctx.data.title,
    description: _ctx.data.description,
    class: "quiz-personal-stage-lightning-round",
    "onQuizNavigation:back": _ctx.navigatePrev,
    "onQuizNavigation:close": _cache[2] || (_cache[2] = ($event: any) => (_ctx.QuizService.close())),
    prev: !_ctx.QuizService.editing.value,
    isVerticallyAligned: ""
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_AppButton, {
        disabled: !_ctx.choice,
        onClick: _ctx.navigateNext
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_QuizSelectableButton, {
            title: _ctx.data.selectable.first.title,
            description: _ctx.data.selectable.first.description,
            selected: _ctx.choice && _ctx.choice.firstOption,
            class: "quiz-personal-stage-lightning-round__selectable-button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setGreatDebateCategory(_ctx.data.value, true)))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.data.selectable.first.emoji), 1)
            ]),
            _: 1
          }, 8, ["title", "description", "selected"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_QuizSelectableButton, {
            title: _ctx.data.selectable.second.title,
            description: _ctx.data.selectable.second.description,
            selected: _ctx.choice && !_ctx.choice.firstOption,
            class: "quiz-personal-stage-lightning-round__selectable-button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setGreatDebateCategory(_ctx.data.value, false)))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.data.selectable.second.emoji), 1)
            ]),
            _: 1
          }, 8, ["title", "description", "selected"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "description", "onQuizNavigation:back", "prev"]))
}